module.exports = __webpack_public_path__ + "static/media/1 3 tattoo leg pirate barnacles.1280x1707.9dbc1dac.webp";